import OffCanvasModal from "components/offCanvas-modal";
import Layout from "layout/layout";
import { productData } from "model/enums";
import React, { useEffect, useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import routes from "routes";
import {
  FloatingLabel,
  Form,
  Spinner,
  Tab,
  Table,
  Tabs,
} from "react-bootstrap";
import EmptyEnterprise from "assets/images/assign-bulk.gif";
import LoadingCircle from "assets/images/loading-circle.gif";
import {
  HiEnvelope,
  HiOutlineEnvelope,
  HiOutlineGlobeAmericas,
  HiOutlineUserGroup,
  HiTrash,
} from "react-icons/hi2";
import { FiArrowDownLeft } from "react-icons/fi";
import GraphShadowIcon from "components/graph-shadow-icon";
import ModalComponent from "components/modal-component";
import { AiOutlineClose } from "react-icons/ai";
import {
  AddEnterprisePlanModel,
  DeleteEnterpriseModel,
  EnterpriseItem,
  EnterprisePlanModel,
  EnterprisePlanQuery,
  EnterprisePlanResponseModel,
} from "model/enterprise-plan-model";
import {
  useActivateEnterprisesubscriptionMutation,
  useCreateEnterprisePlanMutation,
  useDeleteEnterpriseMutation,
  useGetEnterprisePlanQuery,
  useRenewEnterpriseSubMutation,
  useUpdateEnterprisePlanMutation,
  useGetAllTenantsQuery,
  useGetSuspendedTenantsQuery,
  useGetDeletedTenantsQuery,
  useSuspendTenantMutation,
  useReactivateTenantMutation,
  useDeleteTenantMutation
} from "api/enterprisePlanApi";
import dayjs from "dayjs";
import {
  showToastError,
  showToastSuccess,
} from "components/toastify/ToastNotifications";
import { useFormik } from "formik";
import { enterprisePlanSchema } from "validation-schema/enterprise-plan";
import { ApiResponse } from "model/response-model";
import { useGetCountriesQuery } from "api/countryApi";
import { Countries } from "model/countries-model";
import { FormattedDate, FormattedDateOnly } from "components/formatted-date";
import { PiLockKey } from "react-icons/pi";
import { retrieveUserData } from "redux/authSlice";
import { useGetPermissionsByIdQuery } from "api/userManagementApi";
import { HiOutlineDotsHorizontal, HiSearch } from "react-icons/hi";
import { GoSearch } from "react-icons/go";
import Pagination from "rc-pagination/lib/Pagination";
import { BiBlock, BiChevronLeft, BiTrash, BiRefresh, BiUserPlus } from "react-icons/bi";
import info from "../../assets/images/info.gif";
import deleteGif from "../../assets/images/delete-gif.gif";
import suspendGif from "../../assets/images/suspend-gif.gif";
import suspendUserGif from "../../assets/images/suspend-user.gif";
import assignBulkGif from "../../assets/images/assign-bulk.gif";
import reactivateGif from "../../assets/images/reactivate.gif";
import { NumericFormat } from "react-number-format";
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
import CreateEnterprise from "./CreateEnterprise";
import { usePermissions } from "hooks/user-permissions";
import CreateEnterpriseWithoutPayment from "./CreateEnterpriseWithoutPay";
import "../../styles/modal.css";

type Props = {};

const EnterprisePlan = (props: Props) => {
  const navigate = useNavigate();
  const { hasPermissions, isFetching } = usePermissions([
    "View Enterprise Plan",
    "Manage Enterprise Plan",
  ]);

  const [loading, setLoading] = useState("");
  const [searchResult, setSearchResult] = useState(false);
  const [create, setCreate] = useState(false);
  const [createOption, setCreateOption] = useState("withPayment");
  const [selectedPackage, setSelectedPackage] = useState("Joble");
  const [menuSearch, setMenuSearch] = useState("");
  const [show, setShow] = useState(false);
  const [activeRuleStep, setActiveRuleStep] = useState("first");
  const [activeTab, setActiveTab] = useState("all");

  const today = new Date();
  const [searchKeyword, setSearchKeyword] = useState("");
  const [enterprisePlan, setEnterprisePlan] = useState<EnterpriseItem>();
  const [selectedEnterprise, setSelectedEnterprise] =
    useState<EnterprisePlanResponseModel>();
  const [phoneNumber, setPhoneNumber] = useState<any>();
  const [selectedPending, setSelectedPending] = useState<EnterprisePlanResponseModel[]>([]);
  const [selectedSuspended, setSelectedSuspended] = useState<EnterprisePlanResponseModel[]>([]);

  const [enterpriseQuery, setEnterpriseQuery] = useState<EnterprisePlanQuery>({
    pageNumber: 1,
    pageSize: 10,
  });

  const onPageChange = (page: number) => {
    setEnterpriseQuery({ ...enterpriseQuery, pageNumber: page });
    // You can perform actions like fetching data for the new page here
  };

  const handleSearch = () => {
    if (searchKeyword === "") {
      setEnterpriseQuery({ ...enterpriseQuery, searchKeyword: undefined, pageNumber: 1 });
    } else {
      setEnterpriseQuery({ ...enterpriseQuery, searchKeyword: searchKeyword, pageNumber: 1 });
    }
  };

  // const {
  //   data: enterpriseData,
  //   error: enterpriseError,
  //   isFetching: enterpriseIsFetching,
  //   refetch: enterpriseRefetch,
  // } = useGetEnterprisePlanQuery(enterpriseQuery);

  const {
    data: allTenantsData,
    error: allTenantsError,
    isFetching: allTenantsIsFetching,
    refetch: allTenantsRefetch,
  } = useGetAllTenantsQuery();

  useEffect(() => {
    if (allTenantsIsFetching) {
      setLoading("getEnterprise");
    } else {
      setLoading("");
        const rawData = allTenantsData?.data || (allTenantsData as any)?.Data;
        const rawMessage = allTenantsData?.ResponseMessage || (allTenantsData as any)?.ResponseMessage;
        
        if (allTenantsError) {
          showToastError(rawMessage || "Internal server error occur");
        } else {
          const rawItems = Array.isArray(rawData) ? rawData : (rawData?.items || []);
          
          const items = rawItems.map((tenant: any) => ({
            ...tenant,
            enterpriseSubId: tenant.Id || tenant.enterpriseSubId,
            tenantId: tenant.Subdomain || tenant.tenantId, // App uses this as the subdomain for suspended tenant & company details
            subdomain: tenant.Subdomain || tenant.subdomain,
            companyName: tenant.CompanyName || tenant.companyName,
            logo: tenant.LogoUrl || tenant.logo,
            dateRegistered: tenant.DateCreated || tenant.dateRegistered,
            location: tenant.Country || tenant.location,
            adminEmail: tenant.VerifiedEmailDomain || tenant.adminEmail,
            companyType: tenant.CompanyType || tenant.companyType,
            status: tenant.Status || tenant.status
          }));
          setEnterprisePlan({ items } as EnterpriseItem);
        }
    }
  }, [allTenantsIsFetching]);

  const { data: suspendedData, isFetching: suspendedIsFetching, refetch: suspendedTenantsRefetch } = useGetSuspendedTenantsQuery(undefined, { skip: activeTab !== "suspended" });
  const suspendedTenants = useMemo(() => {
    const rawData = suspendedData?.data || (suspendedData as any)?.Data;
    const rawItems = Array.isArray(rawData) ? rawData : (rawData?.items || []);
    return rawItems.map((tenant: any) => ({
      ...tenant,
      enterpriseSubId: tenant.Id || tenant.enterpriseSubId,
      tenantId: tenant.Subdomain || tenant.tenantId,
      subdomain: tenant.Subdomain || tenant.subdomain,
      companyName: tenant.CompanyName || tenant.companyName,
      logo: tenant.LogoUrl || tenant.logo,
      dateRegistered: tenant.DateCreated || tenant.dateRegistered,
      location: tenant.Country || tenant.location,
      adminEmail: tenant.VerifiedEmailDomain || tenant.adminEmail,
      companyType: tenant.CompanyType || tenant.companyType,
      status: tenant.Status || tenant.status
    }));
  }, [suspendedData]);

  const { data: deletedData, isFetching: deletedIsFetching } = useGetDeletedTenantsQuery(undefined, { skip: activeTab !== "deleted" });
  const deletedTenants = useMemo(() => {
    const rawData = deletedData?.data || (deletedData as any)?.Data;
    const rawItems = Array.isArray(rawData) ? rawData : (rawData?.items || []);
    return rawItems.map((tenant: any) => ({
      ...tenant,
      enterpriseSubId: tenant.Id || tenant.enterpriseSubId,
      tenantId: tenant.Subdomain || tenant.tenantId,
      subdomain: tenant.Subdomain || tenant.subdomain,
      companyName: tenant.CompanyName || tenant.companyName,
      logo: tenant.LogoUrl || tenant.logo,
      dateRegistered: tenant.DateCreated || tenant.dateRegistered,
      location: tenant.Country || tenant.location,
      adminEmail: tenant.VerifiedEmailDomain || tenant.adminEmail,
      companyType: tenant.CompanyType || tenant.companyType,
      status: tenant.Status || tenant.status
    }));
  }, [deletedData]);

  const {
    data: countriesData,
    error: countriesError,
    isFetching: countriesIsFetching,
  } = useGetCountriesQuery();
  const [countries, setCountries] = useState<Countries[]>();

  useEffect(() => {
    if (countriesIsFetching) {
    } else {
      if (countriesError) {
        console.error(countriesError);
      } else {
        setCountries(countriesData?.data as Countries[]);
      }
    }
  }, [countriesIsFetching, countriesError]);

  const options = countries?.map((item) => ({
    label: item?.country,
    value: item?.country,
  }));

  const [updateEnterprisePlan, updateEnterprisePlanResult] =
    useUpdateEnterprisePlanMutation();

  const handleLoading = async () => {
    try {
      setActiveRuleStep("loading");
      const model = {
        application: selectedEnterprise?.application,
        provider: "Mollie",
        amountPaid: selectedEnterprise?.amountPaid,
        enterPriseSubId: selectedEnterprise?.enterpriseSubId,
        tenantId: selectedEnterprise?.tenantId,
        maxNumberofUser: selectedEnterprise?.maxNumberofUser,
        isNumberOfUserUnlimited: selectedEnterprise?.isNumberOfUserUnlimited,
        storageInGigaByte: selectedEnterprise?.storageInGigaByte,
        isStorageUnlimited: selectedEnterprise?.isStorageUnlimited,
        communicationHistoryInMonth:
          selectedEnterprise?.communicationHistoryInMonth,
        keepCommunicationForever: selectedEnterprise?.keepCommunicationForever,
        projectLimit: selectedEnterprise?.projectLimit,
        keepProjectCreationForever:
          selectedEnterprise?.keepProjectCreationForever,
        dataRetentionPeriodInMonth:
          selectedEnterprise?.dataRetentionPeriodInMonth,
        keepDataRetentionForever: selectedEnterprise?.keepDataRetentionForever,
        aiAssistance: selectedEnterprise?.aiAssistance,
        unlimitedActivityLog: selectedEnterprise?.unlimitedActivityLog,
        timeSheetManagement: selectedEnterprise?.timeSheetManagement,
      };
      const response = await updateEnterprisePlan(model).unwrap();
      if (response?.ResponseCode === "200" || response?.ResponseCode === "00") {
        console.log("response", response);
        showToastSuccess(response?.ResponseMessage);
        setActiveRuleStep("");
        setShow(false);
        allTenantsRefetch();
      } else {
        setActiveRuleStep("details");
      }
    } catch (error: any) {
      showToastError(error?.data?.ResponseMessage);
      setActiveRuleStep("details");
    }
  };

  const [renewEnterprise] = useRenewEnterpriseSubMutation();

  const handleEnterpriseRenewal = async (tenantId: string, app: string) => {
    try {
      setLoading(tenantId);
      const model = {
        tenantId: tenantId,
        app: app,
      };
      const result = await renewEnterprise(model).unwrap();
      if (result?.ResponseCode == "200") {
        showToastSuccess(result?.ResponseMessage);
      } else {
        showToastError(result?.ResponseMessage);
      }
    } catch (error: any) {
      showToastError(error.ResponseMessage);
    } finally {
      setLoading("");
    }
  };

  const [manualActivation] = useActivateEnterprisesubscriptionMutation();

  const handleActivation = async (
    tenantId: string,
    app: string,
    enterpriseSub: string
  ) => {
    try {
      setLoading(enterpriseSub);
      const model = {
        tenantId: tenantId,
        app: app,
      };
      const result = await manualActivation(model).unwrap();
      if (result?.ResponseCode == "200") {
        showToastSuccess(result?.ResponseMessage);
      } else {
        showToastError(result?.ResponseMessage);
      }
    } catch (error: any) {
      showToastError(error.ResponseMessage);
    } finally {
      setLoading("");
    }
  };

  const [loadingDelete, setLoadingDelete] = useState("");

  const [deleteEnterprise, deleteEnterpriseResult] =
    useDeleteEnterpriseMutation();

  const [deleteTenantMutation] = useDeleteTenantMutation();

  const deleteEnterprisePlan = async () => {
    try {
      if (selectedEnterprise) {
        setLoadingDelete(selectedEnterprise?.enterpriseSubId);
        const currentUser = retrieveUserData();
        
        const response = await deleteTenantMutation({
          subdomain: selectedEnterprise?.tenantId || "",
          deletedBy: currentUser?.userId || "",
          deletionReason: "Deleted from enterprise plan"
        }).unwrap();
        
        if (response?.ResponseCode === "200" || response?.ResponseCode === "00") {
          showToastSuccess(response?.ResponseMessage || "Tenant deleted successfully");
          setCreate(false);
          allTenantsRefetch();
        } else {
          showToastError(response?.ResponseMessage || "Failed to delete tenant");
        }
      }
    } catch (error: any) {
      showToastError(error?.data?.ResponseMessage || "Error deleting tenant");
    } finally {
      setShow(false);
      setLoadingDelete("");
      setSelectedEnterprise(undefined);
    }
  };

  const [suspendTenantMutation, suspendTenantResult] = useSuspendTenantMutation();
  const [loadingSuspend, setLoadingSuspend] = useState(false);

  const [reactivateTenantMutation] = useReactivateTenantMutation();
  const [loadingReactivate, setLoadingReactivate] = useState(false);

  const handleReactivateTenants = async () => {
    if (!selectedSuspended.length) return;
    try {
      setLoadingReactivate(true);
      const results = await Promise.allSettled(
        selectedSuspended.map((item) =>
          reactivateTenantMutation({ subdomain: item.subdomain! }).unwrap()
        )
      );
      const failed = results.filter((r) => r.status === "rejected").length;
      if (failed === 0) {
        showToastSuccess(
          `${selectedSuspended.length} account${selectedSuspended.length !== 1 ? "s" : ""} reactivated successfully`
        );
      } else if (failed < selectedSuspended.length) {
        showToastError(`${failed} of ${selectedSuspended.length} account(s) failed to reactivate`);
      } else {
        showToastError("Failed to reactivate the selected account(s)");
      }
      allTenantsRefetch();
      suspendedTenantsRefetch();
    } catch (error: any) {
      showToastError(error?.data?.ResponseMessage || "Error reactivating tenant(s)");
    } finally {
      setLoadingReactivate(false);
      setShow(false);
      setActiveRuleStep("");
      setSelectedSuspended([]);
    }
  };

  const handleSuspendTenant = async () => {
    if (!selectedEnterprise?.subdomain) return;
    try {
      setLoadingSuspend(true);
      const response = await suspendTenantMutation({ subdomain: selectedEnterprise.subdomain }).unwrap();
      if (response?.ResponseCode === "200" || response?.ResponseCode === "00") {
        console.log("response", response);
        showToastSuccess(response?.ResponseMessage || "Tenant suspended successfully");
        allTenantsRefetch();
      } else {
        showToastError(response?.ResponseMessage || "Failed to suspend tenant");
      }
    } catch (error: any) {
      showToastError(error?.data?.ResponseMessage || "Error suspending tenant");
    } finally {
      setLoadingSuspend(false);
      setShow(false);
      setActiveRuleStep("");
      setSelectedEnterprise(undefined);
    }
  };

  const handleReturn = () => {
    setActiveRuleStep("first");
    setCreate(false);
    allTenantsRefetch();
  };

  const industryOption = [
    "Technology",
    "Healthcare",
    "Finance",
    "Retail",
    "Education",
    "Manufacturing",
    "Transportation",
    "Hospitality",
    "Entertainment",
    "Construction",
  ];

  const [isEditMode, setIsEditMode] = useState(false);
  const [hasChanges, setHasChanges] = useState(false);
  const [originalEnterprise, setOriginalEnterprise] =
    useState<EnterprisePlanResponseModel | null>(null);

  // Function to track changes in form fields
  const handleFieldChange = (field: string, value: any) => {
    if (selectedEnterprise && originalEnterprise) {
      setSelectedEnterprise({
        ...selectedEnterprise,
        [field]: value,
      });

      // Check if there are changes compared to original
      const hasChanges =
        JSON.stringify({
          ...selectedEnterprise,
          [field]: value,
        }) !== JSON.stringify(originalEnterprise);

      setHasChanges(hasChanges);
    }
  };

  // Function to handle edit button click
  const handleEditClick = () => {
    setIsEditMode(true);
    // Store original data for comparison
    if (selectedEnterprise) {
      setOriginalEnterprise({ ...selectedEnterprise });
    }
  };

  // Function to cancel edit
  const handleCancelEdit = () => {
    setIsEditMode(false);
    setHasChanges(false);
    // Restore original data
    if (originalEnterprise) {
      setSelectedEnterprise(originalEnterprise);
    }
  };

  const activeSearch = searchKeyword?.toLowerCase() || "";

  const filteredEnterprisePlanItems = enterprisePlan?.items?.filter((tenant: any) => 
    !activeSearch || 
    tenant.companyName?.toLowerCase().includes(activeSearch) || 
    tenant.adminEmail?.toLowerCase().includes(activeSearch) ||
    tenant.location?.toLowerCase().includes(activeSearch)
  ) || [];

  const filteredSuspendedTenants = suspendedTenants?.filter((tenant: any) =>
    !activeSearch ||
    tenant.companyName?.toLowerCase().includes(activeSearch) || 
    tenant.adminEmail?.toLowerCase().includes(activeSearch) ||
    tenant.location?.toLowerCase().includes(activeSearch)
  ) || [];

  const filteredDeletedTenants = deletedTenants?.filter((tenant: any) =>
    !activeSearch ||
    tenant.companyName?.toLowerCase().includes(activeSearch) || 
    tenant.adminEmail?.toLowerCase().includes(activeSearch) ||
    tenant.location?.toLowerCase().includes(activeSearch)
  ) || [];

  return (
    <Layout>
      <div className="my-4">
        <Form>
          <div className="row">
            <div className="col-lg-11 row">
              {/* <div className='col-lg-4'>
                                <FloatingLabel controlId="floatingSelect" label="Select a Package" className='float-input'>
                                    <Form.Select aria-label="Floating label select example" onChange={(e) => setSelectedPackage(e.target.value)} className="border-0 w-100">
                                        <option value=''>Choose a Package</option>
                                        <option value='Joble'>Joble</option>
                                        <option value='Echo'>Echo </option>
                                        <option value='JobPays'>JobPays</option>
                                        <option value='JobID'>JobID</option>
                                        <option value='JobFy'>JobFy</option>
                                        <option value='JobEvent'>JobEvent</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </div> */}

              <div className="col-lg-4">
                <FloatingLabel
                  controlId="floatingSelect"
                  label="Select country (Optional)"
                  className="float-input"
                >
                  <Form.Select
                    aria-label="Floating label select example"
                    className={`border-0 w-100`}
                  >
                    <option value="">Select country (Optional)</option>
                  </Form.Select>
                </FloatingLabel>
              </div>
              <div className="col-lg-4">
                <FloatingLabel
                  controlId="floatingSelect"
                  label="Choose Plan"
                  className="float-input"
                >
                  <Form.Select
                    onChange={(e) => setMenuSearch(e.target.value)}
                    aria-label="Floating label select example"
                    className="border-0 w-100"
                  >
                    <option value="Enterprise Plan">Enterprise Plan</option>
                  </Form.Select>
                </FloatingLabel>
              </div>

            </div>
            <div className="col-lg-1">
              <button
                type="button"
                onClick={() => {
                  setSearchResult(true);
                  setCreate(false);
                }}
                className="btn-primary"
              >
                View
              </button>
            </div>
          </div>
        </Form>
        {create ? (
          <div
            className="row col-md-6 my-5 rounded mx-auto p-3"
            style={{ backgroundColor: "#f6f6f6" }}
          >
            <Tabs
              defaultActiveKey="withPayment"
              id="uncontrolled-tab-example"
              className=""
            >
              <Tab
                eventKey="withPayment"
                title="Create Paid Enterprise Plan"
                tabClassName="enterpriseTab bg-light text-secondary px-4 border"
              >
                <CreateEnterprise handleReturn={() => handleReturn()} />
              </Tab>
              <Tab
                eventKey="withoutPayment"
                title="Create Free Enterprise Plan"
                tabClassName="enterpriseTab bg-light text-secondary px-4 border"
              >
                <CreateEnterpriseWithoutPayment
                  handleReturn={() => handleReturn()}
                />
              </Tab>
            </Tabs>
          </div>
        ) : selectedPackage ? (
          <div className="row mt-5 mb-4">
            <div className="col-lg-4 my-0 pb-3">
              <div className="card-bl-green bg-white rounded-3 px-4 py-3 ">
                <span className="font-size-mid first-font-medium">
                  Active Enterprise Plans
                </span>
                <div className="d-flex justify-content-between">
                  <h2 className="second-font">{enterprisePlan?.totalSize}</h2>
                  <div className="my-auto">
                    <GraphShadowIcon fillColor="#219653" />
                  </div>
                </div>
                {/* <span className='green-text'><FiArrowDownLeft size={20} className='me-2' /> 9% this month</span> */}
              </div>
            </div>
            <div className="col-lg-4 my-0 pb-3">
              <div className="card-bl-green bg-white rounded-3 px-4 py-3">
                <span className="font-size-mid first-font-medium">
                  Total Funds Generated
                </span>
                <div className="d-flex justify-content-between">
                  <h2 className="second-font">€52,083.00</h2>
                  <div className="my-auto">
                    <GraphShadowIcon fillColor="#219653" />
                  </div>
                </div>
                {/* <span className='green-text'><FiArrowDownLeft size={20} className='me-2' /> 9% this month</span> */}
              </div>
            </div>
            <div className="col-lg-4 my-0 pb-3">
              <div className="card-bl-green bg-white rounded-3 px-4 py-3">
                <span className="font-size-mid first-font-medium">
                  Number of Employees on Enterprise Plan
                </span>
                <div className="d-flex justify-content-between">
                  <h2 className="second-font">
                    {enterprisePlan?.items
                      ?.reduce(
                        (sum, item) => sum + (item?.maxNumberofUser || 0),
                        0
                      )
                      .toLocaleString()}
                  </h2>
                  <div className="my-auto">
                    <GraphShadowIcon fillColor="#219653" />
                  </div>
                </div>
                {/* <span className='green-text'><FiArrowDownLeft size={20} className='me-2' /> 9% this month</span> */}
              </div>
            </div>
            <div className="col-lg-12 pb-4 pt-3">
              <h5 className="fw-bold mb-2">Enterprise Plan</h5>
              <div className="d-flex flex-wrap justify-content-between align-items-center gap-3">
                <div className="d-flex flex-wrap gap-2">
                  <button
                    type="button"
                    onClick={() => setActiveTab("all")}
                    className={`${activeTab === "all"
                      ? "btn-primary-outline"
                      : "btn-secondary-outline"
                      } p-2`}
                  >
                    <HiOutlineUserGroup size={20} className="align-top" /> All
                    Companies
                  </button>
                  <button
                    type="button"
                    onClick={() => setActiveTab("pending")}
                    className={`${activeTab === "pending"
                      ? "btn-primary-outline"
                      : "btn-secondary-outline"
                      } p-2`}
                  >
                    <HiOutlineEnvelope size={20} className="align-top" />{" "}
                    Pending Invites
                  </button>
                  <button
                    type="button"
                    onClick={() => setActiveTab("suspended")}
                    className={`${activeTab === "suspended"
                      ? "btn-primary-outline"
                      : "btn-secondary-outline"
                      } p-2`}
                  >
                    <HiOutlineUserGroup size={20} className="align-top" /> Suspended
                    Companies
                  </button>
                  <button
                    type="button"
                    onClick={() => setActiveTab("deleted")}
                    className={`${activeTab === "deleted"
                      ? "btn-primary-outline"
                      : "btn-secondary-outline"
                      } p-2`}
                  >
                    <BiTrash size={20} className="align-top" /> Trashed
                    Companies
                  </button>
                  {/* <button
                    type="button"
                    className="btn-secondary-outline py-2 px-2"
                  >
                    <HiOutlineDotsHorizontal size={20} className="align-top" />
                  </button> */}
                </div>
                <div className="d-flex flex-wrap gap-2 align-items-center">
                  {activeTab === "all" && (
                    <>
                      {(retrieveUserData()?.roleName === "Super Admin" ||
                        hasPermissions["Manage Enterprise Plan"]) && (
                          <button
                            type="button"
                            onClick={() => setCreate(true)}
                            className="btn-primary p-2"
                          >
                            <HiOutlineGlobeAmericas size={25} /> Create an
                            Enterprise Plan
                          </button>
                        )}
                    </>
                  )}
                  {activeTab === "pending" && selectedPending.length > 1 && (
                    <>
                      <button
                        type="button"
                        onClick={() => {
                          setActiveRuleStep("confirm-revoke");
                          setShow(true);
                        }}
                        className="btn-yellow p-2"
                      >
                        <BiBlock size={25} /> Revoke Invitations
                      </button>
                      <button
                        type="button"
                        onClick={() => setCreate(true)}
                        className="btn-primary p-2"
                      >
                        <HiOutlineEnvelope size={25} /> Send Reminder
                      </button>
                    </>
                  )}
                  {activeTab === "suspended" && selectedSuspended.length > 1 && (
                    <>
                      <button
                        type="button"
                        onClick={() => {
                          setActiveRuleStep("reactivate-bulk");
                          setShow(true);
                        }}
                        className="btn-primary p-2"
                        style={{ backgroundColor: "#1A7458", border: "none" }}
                      >
                        <BiUserPlus size={25} className="me-2" /> Reactivate Selected Companies
                      </button>
                    </>
                  )}
                  <div className="d-flex light-text bg-white border rounded-4 px-2">
                    <Form.Control
                      type="text"
                      placeholder="Search"
                      onChange={(e) => {
                        setSearchKeyword(e.target.value);
                        setEnterpriseQuery({ ...enterpriseQuery, pageNumber: 1 });
                      }}
                      className="border-0 px-2 search-input light-text"
                    />
                    <button
                      type="button"
                      onClick={() => handleSearch()}
                      className="btn text-secondary"
                    >
                      <GoSearch size={23} className="my-auto" />
                    </button>
                  </div>
                </div>
              </div>
              {activeTab === "all" &&
                (allTenantsIsFetching ? (
                  <div className="text-center p-5">
                    <Spinner animation="border" variant="primary" />
                  </div>
                ) : filteredEnterprisePlanItems.length > 0 ? (
                  <>
                    <Table responsive className="table mt-4">
                      <thead>
                        <tr>
                          <th>
                            <label className="fw-normal">SN</label>
                          </th>
                          <th>
                            <label className="fw-normal text-nowrap">
                              Company Name
                            </label>
                          </th>
                          <th>
                            <label className="fw-normal text-nowrap">
                              Registration Date
                            </label>
                          </th>
                          <th>
                            <label className="fw-normal text-nowrap">
                              Location
                            </label>
                          </th>
                          <th>
                            <label className="fw-normal text-nowrap">
                              Admin Email
                            </label>
                          </th>
                          {/* <th>
                            <label className="fw-normal text-nowrap">
                              Max Number of User
                            </label>
                          </th> */}
                          {/* <th>
                            <label className='fw-normal'>Status</label>
                          </th> */}

                          <th>
                            <label className="fw-normal text-nowrap">
                              Company Type
                            </label>
                          </th>
                          <th>
                            <label className="fw-normal"></label>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {filteredEnterprisePlanItems.slice((enterpriseQuery.pageNumber - 1) * 10, enterpriseQuery.pageNumber * 10).map((item, key) => (
                          <tr key={key} className="align-middle">
                            <td className="py-3">
                              <div className="d-flex gap-3 font-size-md text-secondary">
                                <Form.Check type="checkbox" />
                                <span>
                                  {(enterpriseQuery?.pageNumber - 1) *
                                    enterpriseQuery?.pageSize +
                                    key +
                                    1}
                                </span>
                              </div>
                            </td>
                            <td className="py-3 font-size-md text-secondary">
                              <div className="d-flex align-items-center gap-2">
                                {item?.logo ? (
                                  <img src={item.logo} alt="logo" className="rounded-circle" style={{ width: "32px", height: "32px", objectFit: "cover" }} />
                                ) : (
                                  <div
                                    className="rounded-circle d-flex align-items-center justify-content-center text-white font-size-sm"
                                    style={{ width: "41px", height: "41px", backgroundColor: "#008CFE" }}
                                  >
                                    {item?.companyName?.charAt(0)?.toUpperCase()}
                                  </div>
                                )}
                                <span 
                                  className="fw-bold text-dark cursor-pointer" 
                                  onClick={() => navigate(routes.CompanyDetails.replace(":id", item.enterpriseSubId), { state: { subdomain: item.subdomain } })}
                                  style={{ cursor: "pointer" }}
                                >
                                  {item?.companyName}
                                </span>
                              </div>
                            </td>
                            <td className="py-3 font-size-md text-secondary">
                              {FormattedDateOnly(item?.dateRegistered)}
                            </td>
                            <td className="py-3 font-size-md text-secondary">
                              {item?.location}
                            </td>
                            <td className="py-3 font-size-md text-secondary">
                              {item?.adminEmail}
                            </td>
                            <td className="py-3 font-size-md text-secondary">
                              {item?.companyType}
                            </td>
                            {/* <td className="py-3 font-size-md text-center text-secondary">
                              {item?.maxNumberofUser == 0
                                ? "Unlimited"
                                : item?.maxNumberofUser}{" "}
                            </td> */}
                            {/* <td className='py-3 font-size-md text-center text-secondary'>{item?.status} </td> */}
                            <td className="py-3 text-secondary d-flex gap-2">
                              <button
                                type="button"
                                onClick={() => navigate(routes.CompanyDetails.replace(":id", item.enterpriseSubId), { state: { subdomain: item.subdomain } })}
                                className="btn-secondary-outline text-nowrap font-size-md px-3 py-1"
                              >
                                Company Details
                              </button>
                              <button
                                type="button"
                                onClick={() => {
                                  setActiveRuleStep("confirm-suspend");
                                  setShow(true);
                                  setSelectedEnterprise(item);
                                }}
                                className="btn-secondary-outline text-nowrap font-size-md py-1 px-2 text-danger"
                              >
                                <BiBlock size={20} />{" "}
                                Suspend
                              </button>
                              {/* <button
                                type="button"
                                onClick={() =>
                                  handleEnterpriseRenewal(
                                    item?.tenantId,
                                    item?.application
                                  )
                                }
                                className="btn-primary text-nowrap font-size-md py-1 px-2"
                              >
                                Renew Sub{" "}
                                {loading == item?.tenantId && (
                                  <Spinner size="sm" />
                                )}
                              </button> */}
                              <button
                                type="button"
                                onClick={() => {
                                  setActiveRuleStep("confirm-delete");
                                  setShow(true);
                                  setSelectedEnterprise(item);
                                }}
                                className="btn-secondary-outline text-nowrap font-size-md py-1 px-2"
                              >
                                <BiTrash size={20} />{" "}
                                {loadingDelete === item?.enterpriseSubId && (
                                  <Spinner size="sm" />
                                )}{" "}
                                Delete
                              </button>
                              {item?.status !== "Active" && (
                                <button
                                  type="button"
                                  onClick={() =>
                                    handleActivation(
                                      item?.tenantId,
                                      item?.application,
                                      item?.enterpriseSubId
                                    )
                                  }
                                  className="bg-secondary text-nowrap border-0 text-white rounded-3 font-size-md py-1 px-2"
                                >
                                  Activate Plan{" "}
                                  {loading == item?.enterpriseSubId && (
                                    <Spinner size="sm" />
                                  )}
                                </button>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                    <div className="text-end py-3">
                      <Pagination
                        current={enterpriseQuery.pageNumber}
                        total={filteredEnterprisePlanItems.length}
                        pageSize={10}
                        onChange={onPageChange}
                      />
                    </div>
                  </>
                ) : (
                  <div className="text-center p-5"> No data available</div>
                ))}

              {activeTab === "pending" && (false ? (
                  <>
                    <Table responsive className="table mt-4">
                      <thead>
                        <tr>
                          <th>
                            <label className="fw-normal">SN</label>
                          </th>
                          <th>
                            <label className="fw-normal">Company Name</label>
                          </th>
                          <th>
                            <label className="fw-normal">Invitation Date</label>
                          </th>
                          <th>
                            <label className="fw-normal">Location</label>
                          </th>
                          <th>
                            <label className="fw-normal">Company Email</label>
                          </th>
                          <th>
                            <label className="fw-normal"></label>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {filteredEnterprisePlanItems.slice((enterpriseQuery.pageNumber - 1) * 10, enterpriseQuery.pageNumber * 10).map((item, key) => (
                          <tr key={key} className="align-middle">
                            <td className="py-3">
                              <div className="d-flex gap-3 font-size-md text-secondary">
                                <Form.Check
                                  type="checkbox"
                                  checked={selectedPending.some((s) => s.enterpriseSubId === item.enterpriseSubId)}
                                  onChange={(e) => {
                                    if (e.target.checked) {
                                      setSelectedPending([...selectedPending, item]);
                                    } else {
                                      setSelectedPending(
                                        selectedPending.filter(
                                          (s) => s.enterpriseSubId !== item.enterpriseSubId
                                        )
                                      );
                                    }
                                  }}
                                />
                                <span>
                                  {(enterpriseQuery?.pageNumber - 1) *
                                    enterpriseQuery?.pageSize +
                                    key +
                                    1}
                                </span>
                              </div>
                            </td>
                            <td className="py-3 font-size-md text-secondary">
                              <div className="d-flex align-items-center gap-2">
                                {item?.logo ? (
                                  <img src={item.logo} alt="logo" className="rounded-circle" style={{ width: "41px", height: "41px", objectFit: "cover" }} />
                                ) : (
                                  <div
                                    className="rounded-circle d-flex align-items-center justify-content-center text-white font-size-md"
                                    style={{ width: "41px", height: "41px", backgroundColor: "#008CFE" }}
                                  >
                                    {item?.companyName?.charAt(0)?.toUpperCase()}
                                  </div>
                                )}
                                <span 
                                  className="fw-bold text-dark" 
                                  onClick={() => navigate(routes.CompanyDetails.replace(":id", item.enterpriseSubId), { state: { subdomain: item.subdomain } })}
                                  style={{ cursor: "pointer" }}
                                >
                                  {item?.companyName}
                                </span>
                              </div>
                            </td>
                            <td className="py-3 font-size-md text-secondary">
                              {FormattedDateOnly(item?.dateRegistered)}
                            </td>
                            <td className="py-3 font-size-md text-secondary">
                              {item?.location}
                            </td>
                            <td className="py-3 font-size-md text-secondary">
                              {item?.adminEmail}
                            </td>
                            <td className="py-3 font-size-md text-secondary">
                              {selectedPending.length <= 1 && (
                                <>
                                  <button
                                    type="button"
                                    onClick={() => navigate(routes.CompanyDetails.replace(":id", item.enterpriseSubId), { state: { subdomain: item.subdomain } })}
                                    className="btn-secondary-outline px-3 py-1"
                                  >
                                    <HiOutlineEnvelope size={20} /> Send Reminder
                                  </button>
                                  <button
                                    type="button"
                                    onClick={() => {
                                      setActiveRuleStep("confirm-revoke");
                                      setShow(true);
                                      setSelectedEnterprise(item);
                                    }}
                                    className="btn-secondary-outline text-danger mx-2 p-1 text-danger"
                                  >
                                    <BiBlock size={20} /> Revoke Invitation
                                  </button>
                                </>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                    <div className="text-end py-3">
                      <Pagination
                        current={enterpriseQuery.pageNumber}
                        total={filteredEnterprisePlanItems.length}
                        pageSize={10}
                        onChange={onPageChange}
                      />
                    </div>
                  </>
                ) : (
                  <div className="text-center p-5"> No data available</div>
                ))}

              {activeTab === "suspended" &&
                (suspendedIsFetching ? (
                  <div className="text-center p-5">
                    <Spinner animation="border" variant="primary" />
                  </div>
                ) : filteredSuspendedTenants.length > 0 ? (
                  <>
                    <Table responsive className="table mt-4">
                      <thead>
                        <tr>
                          <th>
                            <label className="fw-normal">SN</label>
                          </th>
                          <th>
                            <label className="fw-normal">Company Name</label>
                          </th>
                          <th>
                            <label className="fw-normal">Suspension Date</label>
                          </th>
                          <th>
                            <label className="fw-normal">Location</label>
                          </th>
                          <th>
                            <label className="fw-normal">CompanyEmail</label>
                          </th>
                          <th>
                            <label className="fw-normal">Status</label>
                          </th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {filteredSuspendedTenants.slice((enterpriseQuery.pageNumber - 1) * 10, enterpriseQuery.pageNumber * 10).map((item: any, key: number) => (
                          <tr key={key} className="align-middle">
                            <td className="py-3">
                              <div className="d-flex gap-3 font-size-md text-secondary">
                                <Form.Check
                                  type="checkbox"
                                  checked={selectedSuspended.some((s) => s.enterpriseSubId === item.enterpriseSubId)}
                                  onChange={(e) => {
                                    if (e.target.checked) {
                                      setSelectedSuspended([...selectedSuspended, item]);
                                    } else {
                                      setSelectedSuspended(
                                        selectedSuspended.filter(
                                          (s) => s.enterpriseSubId !== item.enterpriseSubId
                                        )
                                      );
                                    }
                                  }}
                                />
                                <span>
                                  {(enterpriseQuery.pageNumber - 1) * 10 + key + 1}.
                                </span>
                              </div>
                            </td>
                            <td className="py-3 font-size-md text-secondary">
                              <div className="d-flex align-items-center gap-2">
                                {item?.logo ? (
                                  <img src={item.logo} alt="logo" className="rounded-circle" style={{ width: "32px", height: "32px", objectFit: "cover" }} />
                                ) : (
                                  <div
                                    className="rounded-circle d-flex align-items-center justify-content-center text-white font-size-sm"
                                    style={{ width: "32px", height: "32px", backgroundColor: "#008CFE" }}
                                  >
                                    {item?.companyName?.charAt(0)?.toUpperCase()}
                                  </div>
                                )}
                                <span 
                                  className="fw-bold text-dark" 
                                  onClick={() => navigate(routes.CompanyDetails.replace(":id", item.enterpriseSubId), { state: { subdomain: item.subdomain } })}
                                  style={{ cursor: "pointer" }}
                                >
                                  {item?.companyName}
                                </span>
                              </div>
                            </td>
                            <td className="py-3 font-size-md text-secondary">
                              {FormattedDateOnly(item?.dateRegistered)}
                            </td>
                            <td className="py-3 font-size-md text-secondary">
                              {item?.location}
                            </td>
                            <td className="py-3 font-size-md text-secondary">
                              {item?.adminEmail}
                            </td>
                            <td className="py-3 font-size-md" style={{ color: "#F2994A" }}>
                              Suspended
                            </td>
                            <td className="py-3 font-size-md text-secondary">
                              {selectedSuspended.length <= 1 && (
                                <button
                                  type="button"
                                  onClick={() => {
                                    setSelectedSuspended([item]);
                                    setActiveRuleStep("reactivate-bulk");
                                    setShow(true);
                                  }}
                                  className="btn btn-light d-flex align-items-center gap-2 px-3 py-2 fw-bold"
                                  style={{ color: "#219653", backgroundColor: "#F4F5F7", border: "none" }}
                                >
                                  <BiRefresh size={20} /> Reactivate Account
                                </button>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                    <div className="text-end py-3">
                      <Pagination
                        current={enterpriseQuery.pageNumber}
                        total={filteredSuspendedTenants.length}
                        pageSize={10}
                        onChange={onPageChange}
                      />
                    </div>
                  </>
                ) : (
                  <div className="text-center p-5"> No data available</div>
                ))}

              {activeTab === "deleted" &&
                (deletedIsFetching ? (
                  <div className="text-center p-5">
                    <Spinner animation="border" variant="primary" />
                  </div>
                ) : filteredDeletedTenants.length > 0 ? (
                  <>
                    <Table responsive className="table mt-4">
                      <thead>
                        <tr>
                          <th>
                            <label className="fw-normal">SN</label>
                          </th>
                          <th>
                            <label className="fw-normal">Company Name</label>
                          </th>
                          <th>
                            <label className="fw-normal">Suspension Date</label>
                          </th>
                          <th>
                            <label className="fw-normal">Location</label>
                          </th>
                          <th>
                            <label className="fw-normal">Email</label>
                          </th>
                          <th>
                            <label className="fw-normal">Status</label>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {filteredDeletedTenants.slice((enterpriseQuery.pageNumber - 1) * 10, enterpriseQuery.pageNumber * 10).map((item: any, key: number) => (
                          <tr key={key} className="align-middle">
                            <td className="py-3">
                              <div className="d-flex gap-3 font-size-md text-secondary">
                                <Form.Check type="checkbox" />
                                <span>
                                  {(enterpriseQuery.pageNumber - 1) * 10 + key + 1}.
                                </span>
                              </div>
                            </td>
                            <td className="py-3 font-size-md text-secondary">
                              <div className="d-flex align-items-center gap-2">
                                {item?.logo ? (
                                  <img src={item.logo} alt="logo" className="rounded-circle" style={{ width: "32px", height: "32px", objectFit: "cover" }} />
                                ) : (
                                  <div
                                    className="rounded-circle d-flex align-items-center justify-content-center text-white font-size-sm"
                                    style={{ width: "32px", height: "32px", backgroundColor: "#008CFE" }}
                                  >
                                    {item?.companyName?.charAt(0)?.toUpperCase()}
                                  </div>
                                )}
                                <span 
                                  className="fw-bold text-dark" 
                                  onClick={() => navigate(routes.CompanyDetails.replace(":id", item.enterpriseSubId), { state: { subdomain: item.subdomain } })}
                                  style={{ cursor: "pointer" }}
                                >
                                  {item?.companyName}
                                </span>
                              </div>
                            </td>
                            <td className="py-3 font-size-md text-secondary">
                              {FormattedDateOnly(item?.dateRegistered)}
                            </td>
                            <td className="py-3 font-size-md text-secondary">
                              {item?.location}
                            </td>
                            <td className="py-3 font-size-md text-secondary">
                              {item?.adminEmail}
                            </td>
                            <td className="py-3 font-size-md" style={{ color: "#EB5757" }}>
                              Trashed
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                    <div className="text-end py-3">
                      <Pagination
                        current={enterpriseQuery.pageNumber}
                        total={filteredDeletedTenants.length}
                        pageSize={10}
                        onChange={onPageChange}
                      />
                    </div>
                  </>
                ) : (
                  <div className="text-center p-5"> No data available</div>
                ))}
            </div>
          </div>
        ) : (
          <div className="text-center p-5 my-5">
            <img src={EmptyEnterprise} width="120px" />
            <p className="d-block py-3 text-secondary">
              You have not created an Enterprise Subscription yet
            </p>
            {(retrieveUserData()?.roleName === "Super Admin" ||
              hasPermissions["Manage Enterprise Plan"]) && (
                <button
                  type="button"
                  onClick={() => setCreate(true)}
                  className="btn-primary py-2 px-3"
                >
                  <HiOutlineGlobeAmericas size={25} /> Create an Enterprise Plan
                </button>
              )}
          </div>
        )}

        <ModalComponent
          size={undefined}
          showModal={show}
          dialogClassName={activeRuleStep === "confirm-delete" || activeRuleStep === "confirm-suspend" || activeRuleStep === "confirm-revoke" || activeRuleStep === "reactivate-bulk" ? "" : "custom-enterprise-modal"}
          hideModal={() => {
            setShow(false);
            setIsEditMode(false);
            setHasChanges(false);
            setOriginalEnterprise(null);
          }}
        >
          <div className="p-0">
            {/* Custom modal header */}
            {activeRuleStep !== "confirm-delete" && activeRuleStep !== "confirm-suspend" && activeRuleStep !== "confirm-revoke" && activeRuleStep !== "reactivate-bulk" && (
              <div className="d-flex align-items-center justify-content-between p-4">
                <div className="d-flex align-items-center gap-3">
                  {/* Company Logo placeholder */}
                  <div
                    className="rounded-circle bg-primary d-flex align-items-center justify-content-center text-white"
                    style={{ width: "48px", height: "48px" }}
                  >
                    <span className="fw-bold">
                      {selectedEnterprise?.companyName?.charAt(0) || "C"}
                    </span>
                  </div>
                  <div>
                    <h5 className="mb-1 fw-bold text-dark">
                      {selectedEnterprise?.companyName || "Company Name"}
                    </h5>
                    <p className="mb-0 text-muted small">
                      {selectedEnterprise?.adminEmail || "admin@company.com"}
                    </p>
                  </div>
                </div>
                <button
                  className="btn btn-link p-0 text-dark"
                  onClick={() => {
                    setShow(false);
                    setIsEditMode(false);
                    setHasChanges(false);
                    setOriginalEnterprise(null);
                  }}
                >
                  <AiOutlineClose size={24} />
                </button>
              </div>
            )}


            {/* Other modal steps remain the same */}
            {activeRuleStep === "confirm-delete" && (
              <div className="p-4 position-relative">
                <button
                  type="button"
                  onClick={() => {
                    setShow(false);
                    setSelectedEnterprise(undefined);
                    setActiveRuleStep("");
                  }}
                  className="btn btn-md btn-light position-absolute top-0 end-0 m-3 rounded-circle d-flex align-items-center justify-content-center border-0 bg-transparent"
                  style={{ width: "40px", height: "40px" }}
                >
                  <AiOutlineClose size={24} />
                </button>
                <div className="text-center mb-4 mt-2">
                  <img src={deleteGif} width="100px" alt="delete" />
                </div>
                <h5 className="fw-bold text-start mb-3">
                  Delete {selectedEnterprise?.companyName}?
                </h5>
                <p className="text-start text-secondary mb-4" style={{ fontSize: "14px" }}>
                  You are about to delete {selectedEnterprise?.companyName}, they will no longer have access to Joble and their data will be erased. Are you sure you want to proceed?
                </p>
                <button
                  type="button"
                  onClick={() => deleteEnterprisePlan()}
                  disabled={!!loadingDelete}
                  className="btn-primary w-100 border-0 py-3 rounded-4 fw-bold"
                >
                  {loadingDelete ? <Spinner size="sm" /> : "Yes, delete"}
                </button>
              </div>
            )}

            {activeRuleStep === "confirm-suspend" && (
              <div className="p-4 position-relative">
                <button
                  type="button"
                  onClick={() => {
                    setShow(false);
                    setSelectedEnterprise(undefined);
                    setActiveRuleStep("");
                  }}
                  className="btn btn-md btn-light position-absolute top-0 end-0 m-3 rounded-circle d-flex align-items-center justify-content-center border-0 bg-transparent"
                  style={{ width: "40px", height: "40px" }}
                >
                  <AiOutlineClose size={24} />
                </button>
                <div className="text-center mb-4 mt-2">
                  <img src={suspendGif} width="100px" alt="suspend" />
                </div>
                <h5 className="fw-bold text-start mb-3">
                  Suspend {selectedEnterprise?.companyName}?
                </h5>
                <p className="text-start text-secondary mb-4" style={{ fontSize: "14px" }}>
                  You are about to suspend {selectedEnterprise?.companyName}, their access to Joble will be paused. Are you sure you want to proceed?
                </p>
                <button
                  type="button"
                  onClick={handleSuspendTenant}
                  disabled={loadingSuspend}
                  className="btn-primary w-100 border-0 py-3 rounded-4 fw-bold"
                >
                  {loadingSuspend ? <Spinner size="sm" /> : "Yes, suspend"}
                </button>
              </div>
            )}

            {activeRuleStep === "confirm-revoke" && (
              <div className="p-4 position-relative">
                <button
                  type="button"
                  onClick={() => {
                    setShow(false);
                    setSelectedEnterprise(undefined);
                    setActiveRuleStep("");
                  }}
                  className="btn btn-md btn-light position-absolute top-0 end-0 m-3 rounded-circle d-flex align-items-center justify-content-center border-0 bg-transparent"
                  style={{ width: "40px", height: "40px" }}
                >
                  <AiOutlineClose size={24} />
                </button>
                <div className="text-center mb-4 mt-2">
                  <img src={suspendUserGif} width="100px" alt="revoke" />
                </div>
                <h5 className="fw-bold text-start mb-3">
                  Revoke {selectedEnterprise?.companyName ? selectedEnterprise.companyName + "s" : "Selected"} Invitation?
                </h5>
                <p className="text-start text-secondary mb-4" style={{ fontSize: "14px" }}>
                  You are about to revoke invites for the selected company, canceling their access. Are you sure you want to proceed?
                </p>
                <button
                  type="button"
                  onClick={() => {
                    setShow(false);
                    setActiveRuleStep("");
                  }}
                  className="btn-primary w-100 border-0 py-3 rounded-4 fw-bold"
                >
                  Yes, Revoke
                </button>
              </div>
            )}

            {activeRuleStep === "reactivate-bulk" && (
              <div className="p-4 position-relative">
                <button
                  type="button"
                  onClick={() => {
                    setShow(false);
                    setActiveRuleStep("");
                  }}
                  className="btn btn-md btn-light position-absolute top-0 end-0 m-3 rounded-circle d-flex align-items-center justify-content-center border-0 bg-transparent"
                  style={{ width: "40px", height: "40px" }}
                >
                  <AiOutlineClose size={24} />
                </button>
                <div className="text-center mb-4 mt-2">
                  <img src={reactivateGif} width="100px" alt="reactivate" />
                </div>
                <h5 className="fw-bold text-start mb-3">
                  Reactivate Selected Accounts?
                </h5>
                <p className="text-start text-secondary mb-4" style={{ fontSize: "14px" }}>
                  You are about to reactivate the selected account(s), restoring their access. Are you sure you want to proceed?
                </p>
                <button
                  type="button"
                  onClick={handleReactivateTenants}
                  disabled={loadingReactivate}
                  className="btn-primary w-100 border-0 py-3 rounded-4 fw-bold"
                  style={{ backgroundColor: "#0080ff" }}
                >
                  {loadingReactivate
                    ? "Reactivating..."
                    : `Yes, Reactivate ${selectedSuspended.length} Account${selectedSuspended.length !== 1 ? "s" : ""}`}
                </button>
              </div>
            )}

            {activeRuleStep === "confirm-edit" && (
              <div className="text-center p-4">
                <div className="my-3">
                  <img src={info} width="120px" alt="info" />
                </div>
                <p className="fs-5 fw-bold">
                  Confirm change to {selectedEnterprise?.companyName}
                </p>
                <p>
                  The modification you're about to implement will replace the
                  existing settings for <b>{selectedEnterprise?.companyName}</b>
                  . Are you certain you wish to continue?
                </p>
                <div className="d-flex gap-2 pt-3">
                  <button
                    type="button"
                    onClick={() => {
                      setShow(false);
                      setSelectedEnterprise(undefined);
                      setActiveRuleStep("");
                      setIsEditMode(false);
                      setHasChanges(false);
                    }}
                    className="btn-light-red w-50 border-0 py-3 rounded-5"
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    onClick={() => handleLoading()}
                    className="btn-primary w-50 border-0 py-3 rounded-5"
                  >
                    Proceed
                  </button>
                </div>
              </div>
            )}

            {activeRuleStep === "loading" && (
              <div className="p-4">
                <p className="text-secondary text-center">
                  <img
                    src={LoadingCircle}
                    width="40%"
                    className="m-auto d-block"
                    alt="loading"
                  />
                  <span>One moment</span>
                </p>
              </div>
            )}
          </div>
        </ModalComponent>
      </div>
    </Layout>
  );
};

export default EnterprisePlan;


